module.exports = __webpack_public_path__ + "img/image339.9d0c2e54.png";